// extracted by mini-css-extract-plugin
module.exports = {"form":"_bd8be981"};